"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6 5H4v18h12v-2H6z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 1H8v18h12zm-2 14h-8V5h8z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M12.5 10.25h2V12L17 9.5 14.5 7v1.75H11V12h1.5z"
}, "2")], 'OfflineShareSharp');